import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext } from 'react';
import { CollapseContext } from "./CollapseContext";
import { mergePropsAndRefs } from "../../utils";
export var CollapseTrigger = React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  var context = useContext(CollapseContext);

  if (!context) {
    throw new Error('CollapseTrigger must be used within a Collapse element.');
  }

  var bindTrigger = context.bindTrigger;
  var child = React.Children.only(children);

  if (!React.isValidElement(child)) {
    throw new Error('CollapseTrigger must have a valid child');
  }

  return React.cloneElement(child, mergePropsAndRefs(bindTrigger, child.props, other, {
    ref: forwardedRef
  }));
});